import { render, staticRenderFns } from "./DepartmentTableView.vue?vue&type=template&id=ad35a2e0"
import script from "./DepartmentTableView.vue?vue&type=script&lang=js"
export * from "./DepartmentTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports